/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { getActiveWorker } from '@/service/db/Worker';
import { parseKaryaIdToken } from '@/utils/jwt';
import { WorkerRecord } from '@karya/core';
import { useEffect } from 'react';

type UseAutoLoginOptions = {
  onSuccess?: (worker: WorkerRecord) => void;
  onFailure?: () => void;
};
export function useAutoLogin(options?: UseAutoLoginOptions): void {
  useEffect(() => {
    getActiveWorker()
      .unwrapResult()
      .toTuple()
      .then(([worker, activeWorkerError]) => {
        if (activeWorkerError) {
          return options?.onFailure?.();
        }

        const todayInSec = Math.floor(Date.now() / 1000);

        const isLoggedIn = parseKaryaIdToken(worker.id_token)
          .map((parsedToken) => parsedToken.sub === worker.id && parsedToken.exp > todayInSec)
          .getOr(false);

        if (!isLoggedIn) {
          return options?.onFailure?.();
        }

        return options?.onSuccess?.(worker);
      })
      .catch((e) => {
        options?.onFailure?.();
        console.error('Error checking active worker on login page:', e);
      });
    // Don't add options to dependency array to avoid infinite loops
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
